import { gql } from '@apollo/client';

export const DELETE_VISUALIZATION_PRESET_MUTATION = gql`
  mutation DeleteVisualizationPresetMutation($id: ID!) {
    deleteVisualizationPreset(id: $id)
  }
`;
